<template>
  <wrap-container>
    <help-title title="Comercio Exterior" />

    <help-list-container>
      <help-list-item tituloLista="Teléfonos útiles:">
        Comunicate con el centro de atención especializado
        <strong>0800-333-4646</strong> de lunes a viernes de 10 a 16 hs.
      </help-list-item>

      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre comercio exterior en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/comex.html"
        />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink
  }
};
</script>
